'use client';

import RelatedInsights from '@/features/contentful/components/RelatedInsights';
import { useRelatedInsightsContext } from '../contexts/RelatedInsightsProvider';
import { useSettingsContext } from '@/contexts/SettingsContext';
import { useContentfulInspectorMode } from '@contentful/live-preview/react';
import { applyPaddings } from '@/utils/applyPaddings';
import { TypeRelatedInsightsWithoutUnresolvableLinksResponse } from '@/features/contentful/_generated';

const RelatedInsightsGeneric = ({
    id,
    paddingTop,
    paddingBottom,
    type,
}: {
    id?: string;
    paddingTop?: string;
    paddingBottom?: string;
    type: TypeRelatedInsightsWithoutUnresolvableLinksResponse['fields']['type'];
}) => {
    const { items } = useRelatedInsightsContext();
    const { lang, getLabel } = useSettingsContext();
    const RELATED_INSIGHTS_TITLE_LABEL = getLabel('label', 'relatedInsightsTitle');
    const LATEST_INSIGHTS_TITLE_LABEL = getLabel('label', 'latestInsightsTitle');
    const RELATED_READ_MORE_LABEL = getLabel('label', 'relatedInsightsReadMore');
    const RELATED_SEE_ALL_LABEL = getLabel('label', 'relatedInsightsSeeAll');
    const inspectorProps = useContentfulInspectorMode({ entryId: id });

    if (!id || !items[id]) {
        return null;
    }

    return (
        <div
            {...inspectorProps({
                fieldId: 'title',
            })}
            style={applyPaddings({ paddingTop, paddingBottom })}
        >
            <RelatedInsights
                lang={lang}
                title={
                    type === 'Related Insights'
                        ? RELATED_INSIGHTS_TITLE_LABEL
                        : LATEST_INSIGHTS_TITLE_LABEL
                }
                seeAllText={RELATED_SEE_ALL_LABEL}
                readMoreText={RELATED_READ_MORE_LABEL}
                insights={items[id]}
            />
        </div>
    );
};

export default RelatedInsightsGeneric;
